var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.791342 0.0427238L9.99967 6.63447L19.208 0.0441412L19.208 1.77106L9.99967 8.36422L0.791342 1.77106L0.791342 0.0427238ZM0.791341 8.25372L9.99967 14.8469L19.208 8.25231L19.208 9.98064L9.99967 16.5738L0.791341 9.98064L0.791341 8.25372Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMobile);
export default __webpack_public_path__ + "static/media/arrow_mobile.84b2a57311374c9c9fff531cae07cc4c.svg";
export { ForwardRef as ReactComponent };